import { z } from "zod";

export const mfaPhoneNumberSchema = z.object({
	userMfaPhoneNumberId: z.string(),
	userId: z.string(),
	maskedPhoneNumber: z.string(),
	dateCreated: z.string(),
});

export type MfaPhoneNumber = z.infer<typeof mfaPhoneNumberSchema>;

export const PHONE_NUMBER_PATTERN = /^\d{10}$/;

export const PHONE_MASK = "(000) 000-0000";

export function formatPhoneForApi(raw: string): string {
	return "+1" + raw.replaceAll(/[()\s-]/g, "");
}

export function maskPhoneDisplay(maskedPhoneNumber: string): string {
	return maskedPhoneNumber.replaceAll(/[\sX]/g, "\u2022").replaceAll("-", " ");
}
